module.exports = __webpack_public_path__ + "img/Logo_VOLVO.79f98b7f.svg";